module.exports = __webpack_public_path__ + "static/img/costa1.23e18bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/costa1.png
// module id = FrlE
// module chunks = 2